// @ts-strict-ignore
export const SET_BREADCRUMB = 'SET_BREADCRUMB'
export const SET_CTX = 'SET_CTX'
export const SET_PRODUCT_TABLE_SCHEMA = 'SET_PRIMARY_PRODUCT_TABLE_SCHEMA'
export const SET_URL = 'SET_URL'
export const SET_PAGE_DATES = 'SET_PAGE_DATES'
export const SIMPLIFY_CTX = 'SIMPLIFY_CTX'
export const SET_HYDRATION = 'SET_HYDRATION'

export const setBreadcrumb = (payload) => ({ type: SET_BREADCRUMB, payload })
export const setCtx = (payload) => ({ type: SET_CTX, payload })
export const setPrimaryProductTableSchema = (payload) => ({
  type: SET_PRODUCT_TABLE_SCHEMA,
  payload,
})
export const setUrl = (payload) => ({ type: SET_URL, payload })
export const setHydrations = (payload) => ({ type: SET_HYDRATION, payload })
export const setPageDates = (payload) => ({ type: SET_PAGE_DATES, payload })
